<template>
  <div id="planContainer">
    <div class="operations" >
      <el-button  type="primary" icon="el-icon-plus" size="small" @click="add('')">
        新增任务
      </el-button>
      <el-button type="primary" size="small" @click="showTypeChange">
        {{ showType ? "隐藏关键任务" : "显示关键任务" }}
      </el-button>
      <el-button  type="primary" icon="el-icon-download" size="small" plain @click="exportTask">
        导出
      </el-button>
      <el-button type="primary" size="small" plain @click="isShowMapDocs = true">
        图例说明
      </el-button>
      <el-button type="primary" :disabled="!currentTaskId" icon="el-icon-connection" size="small" plain
        @click="linkTask"
      >
        链接任务
      </el-button>
       <!-- <el-button  type="primary"  size="small"  @click="exportTask">
        发布计划
      </el-button> -->
      <el-select v-model="mapTypeValue" size="medium" placeholder="请选择" style="margin: 0 10px; width: 150px"
        filterable @change="mapChange"
      >
        <el-option v-for="item in mapTypeArr" :key="item.value" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="labelFilterValue" size="medium" clearable style="margin: 0 0px" value-key="id" multiple
        collapse-tags placeholder="专业选择" filterable @change="labelChange"
      >
        <el-option v-for="item in taskLabelList" :key="item.id" :label="item.cnName" :value="item">
        </el-option>
      </el-select>
      <el-select v-model="gap" placeholder="请选择时间间隔" size="medium" style="width: 100px; margin-left: 10px" filterable
        @change="timeGapChange"
      >
        <el-option v-for="item in gaps" :key="item.id" :label="item.label" :value="item.id">
        </el-option>
      </el-select>
      <div style="margin-left: 30px">
        <img :src="tishi" alt="" style="vertical-align: middle;" />
        <span style="vertical-align: middle;">
          共{{ tasks.data.length }}条，其中存在警告提醒有
          <span style="color: red">{{
            tasks.data.filter(item => item.taskStatus === 3).length
          }}</span>
          条
        </span>
      </div>
      <el-input v-model="taskSearchValue" size="medium" clearable style="width: 200px; margin-left: 10px"
        placeholder="请输入任务名称"
      ></el-input>
    </div>
    <div class="content">
      <div ref="gantt" style="height: 100%"></div>
      <div v-if="isShowSetHeader" class="setHeader" :style="{ left: setHeaderLeft, top: setHeaderTop }">
        <div>请选择表头显示内容</div>
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="wbs" disabled> 编号 </el-checkbox>
          <el-checkbox label="taskName" disabled> 名称 </el-checkbox>
          <el-checkbox label="taskProgress" disabled> 进度 </el-checkbox>
          <el-checkbox label="labelName"> 专业 </el-checkbox>
          <el-checkbox label="startDate"> 任务开始时间 </el-checkbox>
          <el-checkbox label="endDate"> 任务结束时间 </el-checkbox>
          <el-checkbox label="realEndDate"> 实际完成时间 </el-checkbox>
          <el-checkbox label="planSchedule"> 工期 </el-checkbox>
          <el-checkbox label="taskTypeName"> 任务类型 </el-checkbox>
          <el-checkbox label="preTaskName"> 紧前任务 </el-checkbox>
          <el-checkbox label="afterTaskName"> 紧后任务 </el-checkbox>
          <el-checkbox label="taskUserName"> 责任人 </el-checkbox>
          <el-checkbox label="createUserName"> 创建人 </el-checkbox>
          <el-checkbox label="taskStatusName"> 状态 </el-checkbox>
          <el-checkbox label="operationCode"> 工序编码 </el-checkbox>
          <el-checkbox label="position"> 位置/选择集 </el-checkbox>
          <!-- <el-checkbox label="buttons" disabled> 操作 </el-checkbox> -->
        </el-checkbox-group>
        <div class="btns">
          <el-button size="mini" type="primary" @click="setHeaderConfirm"> 确定 </el-button>
          <el-button size="mini" @click="(isShowSetHeader = false), (checkList = oldCheckList)"> 取消 </el-button>
        </div>
      </div>
      <div v-show="mapTypeValue === '0'" class="foldBtn" :style="{ left: gridCellW + 33 + 'px' }" @click="toggleFold">
        {{ foldStatus ? "收起" : "展开" }}
      </div>
    </div>
    <el-dialog id="eldialogtop3" v-dialogDrag title="导入任务包" :visible.sync="dialogFormVisible3"
      :close-on-click-modal="false" :close-on-press-escape="false"
    >
      <leadingin :key="dd" @clickLidaoru="clickLidaoru1"></leadingin>
      <div slot="footer" class="dialog-footer">
        <el-button style="background: #5587f0; color: #fff" size="mini" @click="adddaoru"> 确 定 </el-button>
        <el-button size="mini" style="background: #909399; color: #fff" @click="dialogFormVisible3 = false"> 取 消 </el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="currentTask.preTaskList" v-dialogDrag class="linkTask" title="链接任务"
      :visible.sync="isShowLinkTaskBox" width="40%" top="17vh" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="linkTaskClose"
    >
      <div class="content" style="margin-bottom: 20px">
        <div class="top">
          <div class="titlecalss">
            <span style="font-weight: bold; font-size: 14px">紧前任务</span>
            <el-button type="primary" icon="el-icon-plus" size="mini" plain @click="(isShowPreTaskBox = true), queryTreeTask()" > 添加 </el-button>
          </div>
          <div class="warp">
            <el-row v-if=" currentTask.preTaskList.filter( item => item.relaStatus === '1' )[0] " :gutter="0">
              <el-col :span="24">
                <div>开始-开始：以下任务开始后，当前任务才能开始</div>
                <div v-for="(item, index) in currentTask.preTaskList.filter( item => item.relaStatus === '1' )"
                  :key="index" class="item"
                  style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; "
                >
                  <span style="color: #538be6">
                    <span style="margin-right: 10px">{{ getWBSCode(item, 1) }}</span>
                    {{ item.preTaskName || item.taskName }}</span>
                  <span>
                    <i class="el-icon-close" style="color: red; cursor: pointer" @click="delPreTask(item, index)"></i>
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row v-if=" currentTask.preTaskList.filter( item => item.relaStatus === '0' )[0] " :gutter="0"
              style="margin-top: 15px"
            >
              <el-col :span="24">
                <div>完成-开始：以下任务完成后，当前任务才能开始</div>
                <div v-for="(item, index) in currentTask.preTaskList.filter( item => item.relaStatus === '0' )"
                  :key="index" class="item"
                  style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; "
                >
                  <span style="color: #538be6">
                    <span style="margin-right: 10px">{{ getWBSCode(item, 1) }}</span>
                    {{ item.preTaskName || item.taskName }}</span>
                  <span>
                    <i class="el-icon-close" style="color: red; cursor: pointer" @click="delPreTask(item, index)"></i>
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="!currentTask.preTaskList[0]" :gutter="0" style="height: 100%; display: flex; align-items: center" >
              <el-col :span="24">
                <div style="text-align: center">
                  <img :src="zanwu" alt="" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="bottom">
          <div class="titlecalss">
            <span style="font-weight: bold; font-size: 14px">紧后任务</span>
          </div>
          <div class="warp">
            <el-row v-if=" currentTask.afterTaskList.filter( item => item.relaStatus === '1' )[0] " :gutter="0">
              <el-col :span="24">
                <div>开始-开始：当前任务开始后，以下任务才能开始</div>
                <div v-for="(item, index) in currentTask.afterTaskList.filter( item => item.relaStatus === '1' )"
                  :key="index" class="item"
                  style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; "
                >
                  <span style="color: #538be6">
                    <span style="margin-right: 10px">{{ getWBSCode(item, 2) }}</span> {{ item.taskName }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row v-if=" currentTask.afterTaskList.filter( item => item.relaStatus === '0' )[0] " :gutter="0">
              <el-col :span="24">
                <div>完成-开始：当前任务结束后，以下任务才能开始</div>
                <div v-for="(item, index) in currentTask.afterTaskList.filter( item => item.relaStatus === '0' )"
                  :key="index" class="item"
                  style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; "
                >
                  <span style="color: #538be6">
                    <span style="margin-right: 10px">{{ getWBSCode(item, 2) }}</span>
                    {{ item.taskName }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row v-if="!currentTask.afterTaskList[0]" :gutter="0" style="height: 100%; display: flex; align-items: center" >
              <el-col :span="24">
                <div style="text-align: center">
                  <img :src="zanwu" alt="" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer" style="padding: 10px 0px 10px">
        <el-button size="small" @click="linkTaskClose">取 消</el-button>
        <el-button type="primary" size="small" @click="addLinkTask">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag class="preTask" title="紧前任务" :visible.sync="isShowPreTaskBox" width="30%" top="20vh"
      :close-on-click-modal="false" :close-on-press-escape="false" @close="preTaskClose"
    >
      <div class="content">
        <div class="top">
          <span>选择紧前任务链接关系</span>
          <div>
            <el-radio v-model="preTaskRadio" label="1">
              开始-开始（所关联紧前任务开始后，当前任务才能开始）
            </el-radio>
            <el-radio v-model="preTaskRadio" label="0">
              完成-开始（所关联紧前任务完成后，当前任务才能开始）
            </el-radio>
          </div>
        </div>
        <div class="bottom">
          <span>选择紧前任务</span>
          <div class="tree">
            <el-input v-model="preTaskFilterText" size="small" style="width: 50%; margin-bottom: 10px"
              placeholder="输入关键字进行过滤" clearable
            >
            </el-input>
            <div class="treeWarp">
              <el-tree ref="preTaskTree" :key="updateKey" check-strictly default-expand-all
                :filter-node-method="preTaskFilterNode" :data="treeTask" node-key="taskId" :props="defaultProps"
                show-checkbox style="background: #f6f9fe" @check="handlePreTaskCheckChange"
              >
                <span slot-scope="{ node, data }" class="custom-tree-node">
                  <span>
                    <span style="margin-right: 10px">{{ getWBSCode(data, 2) }}</span>
                    {{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="preTaskClose">取 消</el-button>
        <el-button type="primary" size="small" @click="addPreTask">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag class="mapDocs" title="图例说明" :visible.sync="isShowMapDocs" width="30%" top="25vh"
      :close-on-click-modal="false" :close-on-press-escape="false" @close="isShowMapDocs = false"
    >
      <div class="content">
        <div class="warp">
          <div class="item">
            <div class="progress" style="background: #69e2b3">
              <div class="solid" style="background: #22ac76"></div>
            </div>
            <div>进行中</div>
          </div>
          <div class="item">
            <div class="progress" style="background: #fdd2d2">
              <div class="solid" style="background: #f75c5c"></div>
            </div>
            <div>已超期</div>
          </div>
          <div class="item">
            <div class="progress" style="background: #dcdcdc"></div>
            <div>未开始</div>
          </div>
          <div class="item">
            <div class="progress" style="background: #a4bafa">
              <div class="solid" style="background: #4689f6; width: 100%"></div>
            </div>
            <div>已完成</div>
          </div>
          <div class="item">
            <div class="progress" style="background: #409eff; height: 2px"></div>
            <div class="link_arrow" style="border-left-color: #409eff"></div>
            <div>开始-开始</div>
          </div>
          <div class="item">
            <div class="progress" style="background: purple; height: 2px"></div>
            <div class="link_arrow"></div>
            <div>完成-开始</div>
          </div>

          <div class="item">
            <div class="progress" style="justify-content: center">
              <img style="width: 13px; margin: 0 4px" src="../../../CommonDP/assets/fileTable/keyTask.png" alt="" />
            </div>
            <div>关键任务</div>
          </div>
          <div class="item">
            <div class="progress" style="justify-content: center">
              <img style="width: 13px; margin: 0 4px" src="../../../CommonDP/assets/fileTable/urging.png" alt="" />
            </div>
            <div>已催办</div>
          </div>
          <div class="item">
            <div class="progress" style="justify-content: center">
              <img style="width: 13px; margin: 0 4px" src="../../../CommonDP/assets/fileTable/overdue.png" alt="" />
            </div>
            <div>已超期</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="isShowMapDocs = false">取 消</el-button>
        <el-button type="primary" size="small" @click="isShowMapDocs = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag title="子项分组管理" :visible.sync="dialogChildIyemVisible" width="30%" top="25vh" class="mapDocs"
      :close-on-click-modal="false" :close-on-press-escape="false"
    >
      <el-table :data="childItemGroupList" height="440px" border>
        <el-table-column property="GroupName" label="子项分组名称" width="200"></el-table-column>
        <el-table-column property="PlanItems" label="包含子项"></el-table-column>
        <el-table-column property="State" label="状态">
          <template slot-scope="{ row }">
            <el-tag :type="row.State == 1 ? 'danger' : 'success'">
              {{ row.State == 1 ? "禁用" : "启用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="changeGroupStatus(row)">
              {{ row.State == 1 ? "启用" : "禁用" }}
            </el-button>
            <el-button type="text" size="small" @click="editChildItemGroup(row)">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer" style="height: 25px">
        <el-button style="float: right" type="primary" size="small" @click="addChildItemGroup">
          新增子项分组
        </el-button>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag class="mapDocs" title="子项分组管理" :visible.sync="addchildItemGroupVisible" width="30%"
      top="30vh" :close-on-click-modal="false" :close-on-press-escape="false"
    >
      <div class="content childItemGroup">
        <el-form ref="childItemGroupForm" :model="childItemGroupForm" :rules="childItemGroupRules" label-width="100px"
          label-position="top" style="width: 100%"
        >
          <el-form-item label="请输入子项分组名称" prop="GroupName">
            <el-input v-model="childItemGroupForm.GroupName"></el-input>
          </el-form-item>
          <el-form-item label="请选择包含子项" prop="PlanItems">
            <el-select v-model="childItemGroupForm.PlanItems" placeholder="请选择包含子项" multiple style="width: 100%"
              filterable
            >
              <el-option v-for="(item, index) in childItemList" :key="item.StageChildName + index"
                :label="item.StageChildName" :value="item.StageChildName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addchildItemGroupVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="saveChildItemGroup('add')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag class="add-edit-detail" title="任务管理" :visible.sync="addEditDetailVisible"
      :close-on-click-modal="false" :close-on-press-escape="false"
    >
      <check-add-edit ref="box11" :task="curTaskId" :show-type="curShowType" @dialogClose="dialogClose" :place-type="1">
      </check-add-edit>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import gantt from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import request from "@/CommonDP/service/progress-service";
import buildPlan from "@/xgzdService/buildPlan-service"
import { mapState } from "vuex";
import { prjplantaskexportexcel, downloadFile } from "@/CommonDP/utils";
import leadingin from "@/CommonDP/components/leadingin";
import taskPackageservice from "@/CommonDP/service/taskPackage-service";
import checkAddEdit from "../task/taskDetail";
export default {
  components: {
    leadingin,
    checkAddEdit
  },
  props:['getTaskList'],
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      addEditDetailVisible: false,
      curShowType: "",
      curTaskId: "",
      gaps: [
        { id: 0, label: "一天" },
        { id: 1, label: "两天" },
        { id: 2, label: "一周" },
        { id: 3, label: "一月" }
      ],
      gap: 0,
      mapTypeArr: [
        {
          name: "甘特图",
          value: "0"
        },
        {
          name: "列表",
          value: "1"
        }
      ],
      mapTypeValue: "0",
      showType: false,
      treeTask: [],
      updateKey: 0,
      splicePreTaskList: [],
      preTaskChecks: [],
      defaultProps: {
        children: "childList",
        label: "taskName"
      },
      isShowMapDocs: false,
      isShowLinkTaskBox: false,
      isShowPreTaskBox: false,
      preTaskRadio: "0",
      preTaskFilterText: "",
      taskLabelList: [], // 所有专业
      labelFilterValue: [],
      taskSearchValue: "",
      currentTaskId: "",
      currentTask: {},
      foldStatus: true,
      isShowSetHeader: false,
      setHeaderLeft: "",
      setHeaderTop: "52px",
      gridCellW: "",
      oldCheckList: [
        "wbs",
        "taskName",
        "taskProgress",
        "labelName",
        "startDate",
        "endDate",
        "planSchedule",
        "taskTypeName",
        "preTaskName",
        "afterTaskName",
        "taskUserName",
        "createUserName",
        "taskStatusName",
        "operationCode",
        "position",
        "buttons",
        "headerSet"
      ],
      checkList: ["wbs", "taskName", "taskProgress", "buttons", "headerSet"],
      tasks: {
        data: [],
        links: []
      },
      originColumns: [
        {
          name: "wbs",
          label: "编号",
          width: 60,
          template: gantt.getWBSCode,
          align: "left"
        },
        {
          name: "taskName",
          tree: true,
          label: "名称",
          width: 200,
          align: "left",
          template: function(task) {
            // todo
            let imgEle = "";
            if (task.coreTask) {
              // 关键任务
              imgEle += `<p class="keyTask" style="width: 13px;margin: 0 4px;"></p>`;
            }
            if (task.taskStatus === 3) {
              // 超期
              imgEle += `<p class="overdue" style="margin: 0 4px;"></p>`;
            }
            if (task.urgeHistory === 1) {
              // 催办状态
              imgEle += `<p class='urging' style="width: 13px;margin: 0 4px;"></p>`;
            }
            if (imgEle.length < 1) {
              imgEle = ``;
            }
            return `<div style="display: flex;align-items: center" title="${task.taskName}" class="">${imgEle}${task.taskName}</div>`;
          }
        },
        {
          name: "taskProgress",
          label: "进度",
          align: "center",
          width: 50,
          template: function(task) {
            return Math.round(task.progress * 100) + "%";
          }
        },
        {
          name: "labelName",
          label: "专业",
          width: 100,
          align: "center",
          template: function(task) {
            return `<div title="${task.labelName ||
              ''}" class="">${task.labelName || ''}</div>`;
          }
        },
        {
          name: "startDate",
          label: "任务开始时间",
          align: "center",
          width: 100
        },
        {
          name: "endDate",
          label: "任务结束时间",
          align: "center",
          width: 100
        },
        {
          name: "realEndDate",
          label: "实际完成时间",
          align: "center",
          width: 100,
          template: function(task) {
            return `<div title="${task.realEndDate ||
              ""}" class="">${task.realEndDate || ""}</div>`;
          }
        },
        {
          name: "planSchedule",
          label: "工期",
          align: "center",
          width: 40
        },
        {
          name: "taskTypeName",
          label: "任务类型",
          align: "center",
          width: 100,
          template: function(task) {
            return `<div title="${task.taskTypeName ||
              ""}" class="">${task.taskTypeName || ""}</div>`;
          }
        },
        {
          name: "preTaskName",
          label: "紧前任务",
          align: "center",
          width: 100,
          template: function(task) {
            return `<div title="${task.preTaskName ||
              ""}" class="">${task.preTaskName || ""}</div>`;
          }
        },
        {
          name: "afterTaskName",
          label: "紧后任务",
          align: "center",
          width: 100,
          template: function(task) {
            return `<div title="${task.afterTaskName ||
              ""}" class="">${task.afterTaskName || ""}</div>`;
          }
        },
        {
          name: "chargeUserList",
          label: "责任人",
          align: "center",
          width: 100,
          template: function(task) {
            const chargeUserList = task.chargeUserList.map((item) => { return item.userName; });
            return `<div title="${chargeUserList ||
              ""}" class="">${chargeUserList || ""}</div>`;
          }
        },
        {
          name: "createUserName",
          label: "创建人",
          align: "center",
          width: 50,
          template: function(task) {
            return `<div title="${task.createUserName ||
              ""}" class="">${task.createUserName || ""}</div>`;
          }
        },
        { name: "taskStatusName", label: "状态", align: "center", width: 60 },
        { name: "operationCode", label: "工序编码", align: "center", width: 60 },
        { name: "position", label: "位置/选择集", align: "center", width: 60 },
        // {
        //   name: "buttons",
        //   label: "操作",
        //   width: 220,
        //   align: "center",
        //   template: () => {
        //     return `
        //       <div class="operations">
        //         <p title="催办" class='urgent'></p>
        //         <p title="编辑" class='edit'></p>
        //         <p title="添加" class='add'></p>
        //         <p title="详情" class='detail'></p>
        //         <p title="删除" class='del'></p>
        //         <p title="上移" class='shangyi'></p>
        //         <p title="下移" class='xiayi'></p>
        //         <p title="升级" class='shengji'></p>
        //         <p title="降级" class='jiangji'></p>
        //       </div>
        //     `;
        //   }
        // },
        {
          name: "headerSet",
          label: this.newLabel(),
          align: "center",
          width: 40
        }
      ],
      filterColumns: [],
      baseColumns: [
        {
          name: "wbs",
          label: "编号",
          width: "60",
          template: gantt.getWBSCode,
          align: "left"
        },
        {
          name: "taskName",
          tree: true,
          label: "名称",
          width: 200,
          align: "left",
          template: function(task) {
            // todo
            let imgEle = "";
            if (task.coreTask) {
              // 关键任务
              imgEle += `<p class="keyTask" style="width: 13px;margin: 0 4px;"></p>`;
            }
            if (task.taskStatus === 3) {
              // 超期
              imgEle += `<p class="overdue" style="margin: 0 4px;"></p>`;
            }
            if (task.urgeHistory === 1) {
              // 催办状态
              imgEle += `<p class='urging' style="width: 13px;margin: 0 4px;"></p>`;
            }
            if (imgEle.length < 1) {
              imgEle = ``;
            }
            return `<div style="display: flex;align-items: center" title="${task.taskName}" class="">${imgEle}${task.taskName}</div>`;
          }
        },
        {
          name: "taskProgress",
          label: "进度",
          align: "center",
          width: 50,
          template: function(task) {
            return Math.round(task.progress * 100) + "%";
          }
        },
        // {
        //   name: "buttons",
        //   label: "操作",
        //   width: 220,
        //   align: "center",
        //   template: () => {
        //     return `
        //       <div class="operations">
        //         <p title="催办" class='urgent'></p>
        //         <p title="编辑" class='edit'></p>
        //         <p title="添加" class='add'></p>
        //         <p title="详情" class='detail'></p>
        //         <p title="删除" class='del'></p>
        //         <p title="上移" class='shangyi'></p>
        //         <p title="下移" class='xiayi'></p>
        //         <p title="升级" class='shengji'></p>
        //         <p title="降级" class='jiangji'></p>
        //       </div>
        //     `;
        //   }
        // },
        {
          name: "headerSet",
          label: this.newLabel(),
          align: "center",
          width: 40
        }
      ],
      locale: {
        date: {
          month_full: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          month_short: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ],
          day_full: [
            "星期日",
            "星期一",
            "星期二",
            "星期三",
            "星期四",
            "星期五",
            "星期六"
          ],
          day_short: ["日", "一", "二", "三", "四", "五", "六"]
        },
        labels: {
          dhx_cal_today_button: "今天",
          day_tab: "日",
          week_tab: "周",
          month_tab: "月",
          new_event: "新建日程",
          icon_save: "保存",
          icon_cancel: "关闭",
          icon_details: "详细",
          icon_edit: "编辑",
          icon_delete: "删除",
          confirm_closing: "请确认是否撤销修改!", // Your changes will be lost, are your sure?
          confirm_deleting: "是否删除日程?",
          section_description: "描述",
          section_time: "时间范围",
          section_type: "类型",

          /* grid columns */

          column_text: "任务名",
          column_start_date: "开始时间",
          column_duration: "持续时间",
          column_add: "",

          /* link confirmation */

          /* message popup */
          message_ok: "确定",
          message_cancel: "取消",

          link: "关联",
          confirm_link_deleting: "将被删除",
          link_start: " (开始)",
          link_end: " (结束)",

          type_task: "任务",
          type_project: "项目",
          type_milestone: "里程碑",

          minutes: "分钟",
          hours: "小时",
          days: "天",
          weeks: "周",
          months: "月",
          years: "年"
        }
      },
      dialogFormVisible3: false,
      dd: "",
      daorupackageId: "",
      setParentDisabledArr: new Set(),
      myTaskClickEvent: null,

      childItemGroupValue: "",
      childItemGroupList: [],
      childItemList: [],
      dialogChildIyemVisible: false,
      addchildItemGroupVisible: false,
      childItemGroupForm: {
        GroupName: "",
        PlanItems: []
      },
      childItemGroupRules: {
        GroupName: [
          { required: true, message: "请输入子项分组名称", trigger: "blur" }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        PlanItems: [
          { required: true, message: "请选择所包含的子项", trigger: "change" }
        ]
      },
      tishi: require("@/CommonDP/assets/settings/tishi.png")
    };
  },
  mounted() {
    this.initDic();
    this.initGantt();
    this.initTaskData();
  },

  methods: {
    dialogClose(isRefresh) {
      this.addEditDetailVisible = false;
      if (isRefresh) this.initTaskData();
    },
    initDic() {
      this.queryTaskLabelList();
      this.queryTreeTask();
      this.querychildItemGroupList();
      this.queryChildItemList();
    },
    getWBSCode(task, type) {
      if (type == 1) return gantt.getWBSCode(gantt.getTask(task.preTaskId));
      return gantt.getWBSCode(gantt.getTask(task.taskId));
    },
    addChildItemGroup() {
      this.addchildItemGroupVisible = true;
      delete this.childItemGroupForm.ID;
      this.$nextTick(() => {
        this.$refs.childItemGroupForm.resetFields();
      });
    },
    editChildItemGroup(row) {
      this.addchildItemGroupVisible = true;
      request.queryChildItemGroupById(row.ID).then(res => {
        if (res.result === "0") {
          this.childItemGroupForm.GroupName = res.data.GroupName;
          this.childItemGroupForm.ID = res.data.ID;
          this.childItemGroupForm.PlanItems = res.data.PlanItems.split(",");
        }
      });
      // this.saveChildItemGroup("modify");
    },
    saveChildItemGroup() {
      this.$refs["childItemGroupForm"].validate(valid => {
        if (valid) {
          let type = "";
          const { prjId } = this.prjInfo;
          const data = {
            groupName: this.childItemGroupForm.GroupName,
            basicPlanID: this.childItemGroupForm.PlanItems.join(",")
          };
          let msg = "";
          if (!this.childItemGroupForm.ID) {
            if (data.id) delete data.id;
            data.prjId = prjId;
            type = "add";
            msg = "添加";
          } else {
            if (data.prjId) delete data.prjId;
            type = "modify";
            data.id = this.childItemGroupForm.ID;
            msg = "修改";
          }
          request.saveChildItemGroup(type, data).then(res => {
            if (res.result === "0") {
              this.querychildItemGroupList();
              this.$message.warning(msg + "成功");
              this.addchildItemGroupVisible = false;
            } else {
              this.$message.warning(res.message || msg + "失败");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeGroupStatus(row) {
      const { ID, State } = row;
      this.$confirm("确定要改变当前状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        request.changeGrouState({ ID, State: 1 - State }).then(res => {
          if (res.result === "0") {
            this.querychildItemGroupList();
            this.$message.warning("修改状态成功");
          }
        });
      });
    },
    queryChildItemList() {
      const { prjId } = this.prjInfo;
      request.queryChildItemList(prjId).then(res => {
        this.childItemList = res.data;
      });
    },
    querychildItemGroupList() {
      const { prjId } = this.prjInfo;
      request.queryChildItemGroupList(prjId).then(res => {
        this.childItemGroupList = res.data;
      });
    },
    queryTaskLabelList() {
      buildPlan.getSpecList().then(res => {
        if (res.result === "0") {
          this.taskLabelList = res.data;
        }
      });
    },

    queryTreeTask() {
      const { prjId } = this.prjInfo;
      const isCore = 1;
      const { conPlanId } = this.$route.query;
      buildPlan.queryPlanList({ prjId, isCore, labelIds: [], enterpriseId: this.enterpriseId },conPlanId)
        .then(res => {
          if (res.result === "0") {
            // this.currentTask.preTaskList紧前
            if (res.data.list) {
              for (var t = 0; t < res.data.list.length; t++) {
                if (this.currentTask.preTaskList) {
                  for (
                    var b = 0;
                    b < this.currentTask.preTaskList.length;
                    b++
                  ) {
                    if (
                      res.data.list[t].taskId ==
                      this.currentTask.preTaskList[b].preTaskId
                    ) {
                      this.$set(res.data.list[t], "disabled", true);
                    }
                  }
                }
                // this.currentTask.afterTaskList 紧后
                if (this.currentTask.afterTaskList) {
                  for (
                    var b = 0;
                    b < this.currentTask.afterTaskList.length;
                    b++
                  ) {
                    if (
                      res.data.list[t].taskId ==
                      this.currentTask.afterTaskList[b].taskId
                    ) {
                      this.$set(res.data.list[t], "disabled", true);
                    }
                  }
                }
              }
              this.treeTask = res.data.list.map((item)=>{
                return{
                  labelName:item.specList.map((a) => { return a.specName}),
                  ...item
                }
              });
              this.filterArray(this.treeTask, this.currentTaskId);
            }
          }
        });
    },
    filterArray(data, taskId) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].taskId == taskId) {
          data[i].disabled = true;
          this.filterArray(data, data[i].parentId);
        }
      }
      this.treeTask = data;
      this.filterArray2(this.treeTask, this.currentTaskId);
    },
    filterArray2(data, id) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId == id) {
          data[i].disabled = true;
          this.filterArray2(data, data[i].taskId);
        }
      }
      this.treeTask = this.filterArray1(data, 0);
    },
    filterArray1(data, parentId) {
      const tree = [];
      let temp;
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId == parentId) {
          const obj = data[i];
          temp = this.filterArray1(data, data[i].taskId);
          if (temp.length > 0) {
            obj.childList = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },

    initTaskData(isChangePrj) {
      const { x, y } = gantt.getScrollState();
      const { prjId } = this.prjInfo;
      const { conPlanId } = this.$route.query;
      const isCore = this.showType ? 2 : 1;
      const labelIds = [];
      buildPlan.queryPlanList({ prjId, labelIds, isCore, enterpriseId: this.enterpriseId },conPlanId)
        .then(res => {
          if (res.result === "0") {
            let { links, list } = res.data;
            links = links || [];
            list = list || [];
            list.forEach(item => {
              item.id = item.taskId;
              item.parent = item.parentId;
              item.start_date = item.startDate;
              item.end_date = this.addOnDay(item.endDate, 1);
              item.open = true;
              item.progress = item.taskProgress / 100;
              item.labelName=item.specList?.map((a) => { return a.specName})?.toString()
            });
            this.tasks.data = list;
            this.tasks.links = links;
            this.getTaskList(this.tasks.data)
            gantt.init(this.$refs.gantt);
            gantt.clearAll();
            gantt.parse(this.tasks);
            this.countGridCellW();
            if (this.currentTaskId) {
              this.currentTask = list.find(
                item => item.taskId === this.currentTaskId
              );
            }
            this.scrollTo(isChangePrj ? 0 : x, isChangePrj ? 0 : y);
          }
        });
    },

    add(type, id) {
      type = type || "add";
      if (type !== "add") {
        // this.$router.push({
        //   name: "buildTaskDeatail",
        //   query: {
        //     showType: type,
        //     task: id || "0",
        //     conPlanId: this.$route.query.conPlanId
        //   }
        // });
      } else {
        this.curShowType = type;
        this.curTaskId = id || "0";
        this.addEditDetailVisible = true;
        this.$nextTick(() => {
          this.$refs.box11.qinkong();
        });
      }
    },

    delPreTask(item) {
      this.removeByValue(
        this.currentTask.preTaskList,
        "preTaskId",
        item.preTaskId
      );
    },
    removeByValue(arr, attr, value) {
      // 数组，属性，属性值
      var index = 0;
      for (var i in arr) {
        if (arr[i][attr] === value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    // 点击导入 右边任务包
    clickLidaoru1(id) {
      this.daorupackageId = id;
    },
    // 确定 导入
    adddaoru() {
      const { prjId } = this.prjInfo;
      this.dialogFormVisible3 = false;
      var data = {
        packageId: this.daorupackageId,
        prjId: prjId,
        taskId: ""
      };
      // console.log(data,'data')
      if (this.currentTaskId) {
        data.taskId = this.currentTaskId;
      }
      taskPackageservice.prjplantaskimporttask(data).then(res => {
        if (res.result === "0") {
          this.$message({
            duration: 1000,
            message: "导入成功",
            type: "success",
            showClose: true
          });
          this.initTaskData();
        }
      });
    },
    // 导出
    exportTask() {
      this.$confirm("确定要导出吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        const { prjId } = this.prjInfo;
        const downzipurl = prjplantaskexportexcel(prjId);
        this.$message({
          message: "数据已生成！",
          type: "success"
        });
        downloadFile(downzipurl);
      });
    },

    linkTask() {
      this.initTaskData();
      this.queryTreeTask();
      this.isShowLinkTaskBox = true;
    },

    configTimeGap() {
      switch (this.gap) {
        case 0:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 1, format: "%j %M" }
          ];
          break;
        case 1:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 2, format: "%j %M" }
          ];
          break;
        case 2:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 7, format: "%j %M" }
          ];
          break;
        case 3:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "month", step: 1, format: "%F" }
          ];
          break;

        default:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 1, format: "%j %M" }
          ];
          break;
      }
    },

    initGantt() {
      gantt.config.xml_date = "%Y-%m-%d";
      gantt.config.drag_move = false;
      gantt.config.drag_progress = false;
      gantt.config.details_on_dblclick = false;
      gantt.config.drag_resize = false;
      this.configTimeGap();
      gantt.templates.task_text = (start, end, task) => {
        const code = gantt.getWBSCode(task);
        return code + " " + task.taskName;
      };

      gantt.templates.link_class = function(link) {
        const { type } = link;
        if (type === "1") return "start_start_link";
        else return "end_start_link";
      };

      gantt.templates.task_class = function(start, end, task) {
        if (task.coreTask === 2) return "key";
        let taskClass = "without";
        switch (task.taskStatus) {
          case 0:
            taskClass = "without";
            break;
          case 1:
            taskClass = "low";
            break;
          case 2:
            taskClass = "medium";
            break;
          case 3:
            taskClass = "high";
            break;
        }
        return taskClass;
      };
      gantt.attachEvent("onBeforeTaskDisplay", (id, task) => {
        const labelFilterValue = this.labelFilterValue;

        const childItemGroupValue = this.childItemGroupValue
          ? this.childItemGroupValue.split(";")[1]
          : "";
        task.open = true;
        if (!labelFilterValue[0] && !childItemGroupValue) {
          return true;
        } else {
          const taskLabelList = task.labelName ? task.labelName.split(",") : [];
          const isHas = taskLabelList.filter(item =>
            labelFilterValue.some(Item => Item.cnName === item)
          );
          const gpHas = task.prjStageChildPlanGroupName === childItemGroupValue;
          if (labelFilterValue[0] && childItemGroupValue) {
            return isHas[0] && gpHas;
          }
          if (labelFilterValue[0]) {
            return isHas[0];
          }
          if (childItemGroupValue) {
            return gpHas;
          }
        }
      });

      gantt.attachEvent("onTaskDblClick", (id, e) => {
        this.add("check", id);
        return true;
      });

      gantt.templates.timeline_cell_class = function(item, date) {
        if (date.getDay() == 0 || date.getDay() == 6) {
          return "weekend";
        }
      };

      gantt.attachEvent("onAfterLinkAdd", (id, item) => {
        this.addLinkTaskDrag(item);
      });

      gantt.attachEvent("onAfterLinkDelete", (id, item) => {
        this.delLinkTaskDbClick(item);
      });

      gantt.config.columns = this.originColumns;
      gantt.locale = this.locale;
      this.taskClick();
      gantt.plugins({
        multiselect: true
      });

      gantt.init(this.$refs.gantt);
      this.$store.commit("UPDATE_GANTT", gantt);
      this.countGridCellW();
    },

    delLinkTaskDbClick(data) {
      request.delLinkTaskDbClick(data).then(res => {});
    },

    addLinkTaskDrag(data) {
      request.addLinkTaskDrag(data).then(res => {});
    },

    taskClick() {
      if (!this.myTaskClickEvent) {
        this.myTaskClickEvent = gantt.attachEvent("onTaskClick", (id, e) => {
          this.currentTaskId = id;
          this.currentTask = this.tasks.data.find(item => item.id === id);
          const title = e.target.title;
          if (title) {
            switch (title) {
              case "催办":
                this.urgePlan();
                break;
              case "编辑":
                this.add("edit", id);
                break;
              case "添加":
                this.add("add", id);
                break;
              case "详情":
                this.add("check", id);
                break;
              case "删除":
                this.delPlan(id);
                break;
              case "上移":
                this.move(id, 0);
                break;
              case "下移":
                this.move(id, 1);
                break;
              case "升级":
                this.upgrade(id, 0);
                break;
              case "降级":
                this.upgrade(id, 1);
                break;
              default:
                this.currentTaskId = id;
                this.currentTask = this.tasks.data.find(item => item.id === id);
            }
          }
          return true;
        });
      }
    },

    urgePlan() {
      const {
        taskName,
        start_date,
        endDate,
        taskStatusName,
        taskId,
        taskUserName,
        chargeUserList,
        taskType,
        taskTypeName,
        taskUserId
      } = this.currentTask;
      const { x, y } = gantt.getScrollState();
      this.$confirm(
        `任务【${taskName}】起止时间为 ${moment(start_date).format(
          "YYYY-MM-DD"
        )} 至 ${endDate} ，目前状态为 ${taskStatusName} 是否立即进行催办提醒?`,
        "催办提醒",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        //  prjId 项目id
        //  topic 主题           催办提醒: 任务名称
        //  targetItemType 待办大类(数字))  0
        //  urgeObjectiveUserId   催办人员id,通过| 拼接
        //  urgeObjectiveName 催办人员名称,通过|分割
        //  targetItemId 催办事项Id
        //  specificItemType 待办小类(数字) 0:催办 1：修改责任人
        if (chargeUserList.length > 0) {
          const { prjId } = this.prjInfo;
          let urgeObjectiveUserId = chargeUserList?.map((item) => item.userId) .join(",");
          let urgeObjectiveName = chargeUserList?.map((item) => item.userName) .join(",");
          const data = {
            prjId,
            topic: "催办提醒：" + taskName,
            targetItemName: taskName,
            targetItemType: 0,
            urgeObjectiveUserId,
            urgeObjectiveName,
            targetItemId: taskId,
            specificItemType: 0,
            taskType,
            taskTypeName
          };
          request.urgePlan(data).then(res => {
            if (res.result === "0") {
              this.$message.success("催办成功");
              this.initTaskData();
              this.countGridCellW();
              this.scrollTo(x, y);
            } else {
              this.$message.warning(res.message || "催办失败");
            }
          });
        } else {
          this.$message.warning("责任人不能为空");
        }
      });
    },
    delPlan(id) {
      this.$confirm("确定删除此任务吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        request.delPlan(id).then(res => {
          if (res.result === "0") {
            gantt.deleteTask(id);
            this.initTaskData();
            this.resetCurrentTask();
            this.$message.success("删除成功");
          }
        });
      });
    },
    move(id, type) {
      buildPlan.movePlan(id, type).then(res => {
        if (res.result === "0") {
          this.initTaskData();
          this.$message.success("移动成功");
        }
      });
    },

    upgrade(id, type) {
      const tasks = gantt.getTaskBy(task => task.id === id);
      const { preTaskName, afterTaskName } = tasks[0];
      if (preTaskName || afterTaskName) {
        this.$confirm(
          type === 0
            ? "当前任务已关联其他任务，进行升级操作后，关联关系将自动丢失，是否确认升级？"
            : "当前任务已关联其他任务，进行降级操作后，关联关系将自动丢失，是否确认降级？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.upAndDownPlan(id, type);
        });
      } else {
        this.upAndDownPlan(id, type);
      }
    },

    upAndDownPlan(id, type) {
      request.upAndDownPlan(id, type).then(res => {
        if (res.result === "0") {
          this.initTaskData();
          this.$message.success(`${type === 0 ? "升级" : "降级"}成功`);
        }
      });
    },

    newLabel() {
      gantt.bindSetHeaderClick = this.bindSetHeaderClick;
      return `<div style="display: flex;align-items: center;height: 100%;cursor: pointer;justify-content: center;position: relative;">
              <p id="setHeader" onclick="gantt.bindSetHeaderClick()"/>
            </div>`;
    },

    toggleFold() {
      const { x, y } = gantt.getScrollState();
      this.foldStatus ? this.fold() : this.unfold();
      this.countGridCellW();
      this.foldStatus = !this.foldStatus;
      this.scrollTo(x, y);
    },

    setHeaderConfirm() {
      const { x, y } = gantt.getScrollState();
      const filterColumns = [];
      this.originColumns.forEach(item => {
        if (this.checkList.some(Item => Item === item.name)) {
          filterColumns.push(item);
        }
      });
      this.filterColumns = filterColumns;
      this.isShowSetHeader = false;
      if (this.foldStatus) {
        gantt.config.columns = filterColumns;
        gantt.init(this.$refs.gantt);
        gantt.parse(this.tasks);
      }
      this.countGridCellW();
      this.oldCheckList = this.checkList;
      this.scrollTo(x, y);
    },

    unfold() {
      gantt.config.columns = this.originColumns[0]
        ? this.originColumns
        : this.originColumns;
      gantt.init(this.$refs.gantt);
      gantt.parse(this.tasks);
    },

    fold() {
      gantt.config.columns = this.filterColumns[0]
        ? this.filterColumns
        : this.baseColumns;
      gantt.init(this.$refs.gantt);
      gantt.parse(this.tasks);
    },

    scrollTo(x, y) {
      gantt.scrollTo(x, y);
    },

    labelChange(value) {
      gantt.refreshData();
    },

    showTypeChange() {
      this.showType = !this.showType;
      this.initTaskData();
    },

    timeGapChange() {
      const fs = !this.foldStatus;
      const { x, y } = gantt.getScrollState();
      this.initGantt();
      this.configTimeGap;
      // this.initTaskData();
      fs ? this.fold() : this.unfold();
      this.countGridCellW();
      this.scrollTo(x, y);
    },

    mapChange(value) {
      const { x, y } = gantt.getScrollState();
      gantt.config.show_chart = value === "0";
      if (value === "1") {
        gantt.config.columns = [
          {
            name: "wbs",
            label: "编号",
            width: 60,
            template: gantt.getWBSCode,
            align: "left"
          },
          {
            name: "taskName",
            tree: true,
            label: "名称",
            width: 200,
            align: "left",
            template: function(task) {
              // todo
              let imgEle = "";
              if (task.coreTask) {
                // 关键任务
                imgEle += `<p class="keyTask" style="width: 13px;margin: 0 4px;"></p>`;
              }
              if (task.taskStatus === 3) {
                // 超期
                imgEle += `<p class="overdue" style="margin: 0 4px;"></p>`;
              }
              if (task.urgeHistory === 1) {
                // 催办状态
                imgEle += `<p class='urging' style="width: 13px;margin: 0 4px;"></p>`;
              }
              if (imgEle.length < 1) {
                imgEle = ``;
              }
              return `<div style="display: flex;align-items: center" title="${task.taskName}" class="">${imgEle}${task.taskName}</div>`;
            }
          },
          {
            name: "taskProgress",
            label: "进度",
            align: "center",
            width: 50,
            template: function(task) {
              return Math.round(task.progress * 100) + "%";
            }
          },
          {
            name: "labelName",
            label: "专业",
            width: 100,
            align: "center",
            template: function(task) {
              return `<div title="${task.labelName ||
                ""}" class="">${task.labelName || ""}</div>`;
            }
          },
          {
            name: "startDate",
            label: "任务开始时间",
            align: "center",
            width: 100
          },
          {
            name: "endDate",
            label: "任务结束时间",
            align: "center",
            width: 100
          },
          { name: "planSchedule", label: "工期", align: "center", width: 40 },
          {
            name: "taskTypeName",
            label: "任务类型",
            align: "center",
            width: 100,
            template: function(task) {
              return `<div title="${task.taskTypeName ||
                ""}" class="">${task.taskTypeName || ""}</div>`;
            }
          },
          {
            name: "preTaskName",
            label: "紧前任务",
            align: "center",
            width: 100,
            template: function(task) {
              return `<div title="${task.preTaskName ||
                ""}" class="">${task.preTaskName || ""}</div>`;
            }
          },
          {
            name: "afterTaskName",
            label: "紧后任务",
            align: "center",
            width: 100,
            template: function(task) {
              return `<div title="${task.afterTaskName ||
                ""}" class="">${task.afterTaskName || ""}</div>`;
            }
          },
          {
            name: "taskUserName",
            label: "责任人",
            align: "center",
            width: 100,
            template: function(task) {
              return `<div title="${task.taskUserName ||
                ""}" class="">${task.taskUserName || ""}</div>`;
            }
          },
          {
            name: "createUserName",
            label: "创建人",
            align: "center",
            width: 50,
            template: function(task) {
              return `<div title="${task.createUserName ||
                ""}" class="">${task.createUserName || ""}</div>`;
            }
          },
          { name: "taskStatusName", label: "状态", align: "center", width: 60 },
          { name: "operationCode", label: "工序编码", align: "center", width: 60 },
          { name: "position", label: "位置/选择集", align: "center", width: 60 },
          // {
          //   name: "buttons",
          //   label: "操作",
          //   width: 220,
          //   align: "center",
          //   template: () => {
          //     return `
          //       <div class="operations">
          //         <p title="催办" class='urgent'></p>
          //         <p title="编辑" class='edit'></p>
          //         <p title="添加" class='add'></p>
          //         <p title="详情" class='detail'></p>
          //         <p title="删除" class='del'></p>
          //         <p title="上移" class='shangyi'></p>
          //         <p title="下移" class='xiayi'></p>
          //         <p title="升级" class='shengji'></p>
          //         <p title="降级" class='jiangji'></p>
          //         </div>
          //     `;
          //   }
          // }
        ];
        gantt.init(this.$refs.gantt);
        gantt.parse(this.tasks);
      } else {
        gantt.config.columns = this.foldStatus
          ? this.originColumns
          : this.filterColumns[0]
            ? this.filterColumns
            : this.baseColumns;
        this.initTaskData();
      }
      this.countGridCellW();
      this.scrollTo(x, y);
    },

    resetCurrentTask() {
      this.currentTaskId = "";
      this.currentTask = {};
    },

    countGridCellW() {
      this.$nextTick(() => {
        this.gridCellW = document.querySelector(".grid_cell").clientWidth;
        this.setHeaderLeft = this.gridCellW - 140 + 15 + "px";
      });
    },

    bindSetHeaderClick() {
      this.$nextTick(() => {
        this.gridCellW = document.querySelector(".grid_cell").clientWidth;
        this.setHeaderLeft = this.gridCellW - 140 + 15 + "px";
        this.isShowSetHeader = !this.isShowSetHeader;
      });
    },

    handlePreTaskCheckChange(data, nodes) {
      this.preTaskChecks = nodes.checkedNodes;
    },

    linkTaskClose() {
      const preTaskList = this.currentTask.preTaskList || [];
      const oldPreTaskList = preTaskList.filter(item => !item.old);
      if (this.splicePreTaskList[0]) {
        this.splicePreTaskList.forEach(item => {
          oldPreTaskList.push(item);
        });
      }
      const { id } = this.currentTask;
      this.currentTask.preTaskList = oldPreTaskList;
      let dataTask = this.tasks.data.find(item => item.id === id);
      dataTask = dataTask || {};
      dataTask.preTaskList = oldPreTaskList;
      this.isShowLinkTaskBox = false;
      this.splicePreTaskList = [];
      this.setParentDisabledArr = new Set();
    },

    addPreTask() {
      this.preTaskChecks.forEach(item => {
        const { taskId, taskName } = item;
        const obj = {
          relaStatus: this.preTaskRadio,
          preTaskId: taskId,
          preTaskName: taskName,
          old: true
        };
        if (
          !this.currentTask.preTaskList.some(
            Item => Item.preTaskId === obj.preTaskId
          )
        ) {
          this.currentTask.preTaskList.push(obj);
        }
      });
      this.preTaskClose();
    },

    preTaskClose() {
      this.preTaskRadio = "0";
      this.preTaskFilterText = "";
      this.preTaskChecks = [];
      this.treeTask = [...this.treeTask];
      this.isShowPreTaskBox = false;
    },

    preTaskFilterNode(value, data) {
      if (!value) return true;
      return data.taskName.indexOf(value) !== -1;
    },

    addLinkTask() {
      const { preTaskList, taskId, taskName } = this.currentTask;
      const relationTaskList = preTaskList.map(item => ({
        relaStatus: item.relaStatus,
        taskId: item.preTaskId,
        taskName: item.preTaskName
      }));
      request.addLinkTask({ relationTaskList, taskId, taskName }).then(res => {
        if (res.result === "0") {
          this.$message.success("添加成功");
          this.isShowLinkTaskBox = false;
          this.initTaskData();
        }
      });
    },

    addOnDay(time, num) {
      return moment(time)
        .add(num, "days")
        .format("YYYY-MM-DD");
    }
  },

  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    childItemGroupListFiltered() {
      return this.childItemGroupList.filter(item => item.State == 0);
    }
  },

  watch: {
    prjInfo: {
      deep: true,
      handler: function({ prjId }, oldValue) {
        if (prjId) {
          this.resetCurrentTask();
          this.initTaskData(true);
          this.queryChildItemList();
          this.querychildItemGroupList();
        }
      }
    },

    preTaskFilterText(val) {
      this.$refs.preTaskTree.filter(val);
    },

    taskSearchValue(value, oldValue) {
      const selectTask = gantt.getSelectedTasks();
      selectTask.forEach(item => {
        gantt.toggleTaskSelection(item);
      });
      gantt.render();
      if (value) {
        const tasks = gantt.getTaskByTime();
        tasks.forEach(item => {
          if (item.taskName.includes(value)) {
            gantt.toggleTaskSelection(item.id);
          }
        });
        gantt.render();
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    gantt.detachEvent(this.myTaskClickEvent);
    this.myTaskClickEvent = "";
    this.labelFilterValue = [];
    gantt.config.show_chart = true;
    next();
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#planContainer {
  height: 100%;
  width: 100%;
  background-color: #fff;
  .link_arrow {
    margin-left: -13px;
    margin-right: 8px;
    background-color: transparent;
    border-width: 4px 0px 4px 6px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    border-left-color: purple;
    border-style: solid;
  }

  /deep/ .end_start_link {
    .gantt_line_wrapper>* {
      background-color: purple !important;
    }

    .gantt_link_arrow_right {
      border-left-color: purple !important;
    }

    .gantt_link_arrow_left {
      border-left-color: purple !important;
    }
  }

  /deep/ .start_start_link {
    .gantt_line_wrapper>* {
      background-color: #409EFF !important;
    }

    .gantt_link_arrow_right {
      border-left-color: #409EFF !important;
    }

    .gantt_link_arrow_left {
      border-left-color: #409EFF !important;
    }
  }

  .operations {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    flex-wrap:wrap;
    padding: 0 31px;padding-top:16px;
    .el-button--primary {
      background: #4777E7;
      border-color: #4777E7;
    }

    .el-button--primary:hover {
      background: #7397EC;
      border-color: #7397EC;
    }

    .el-button--primary.is-plain {
      background: #fff;
      border-color: #4777E7;
      color: #4777E7;
    }

    .el-button--primary.is-plain:hover {
      background: #E1EAFF;
      border-color: #4777E7;
      color: #4777E7;
    }
  }

  .content {
    width: 100%;
    height: calc(100% - 80px);
    padding: 15px 31px 0 31px;
    box-sizing: border-box;
    position: relative;

    /deep/ .gantt_layout_root {
      .grid_cell {
        .gantt_row:hover .operations {
          display: flex;
        }

        .gantt_row {
          .gantt_tree_content {
            >div {
              overflow: hidden;
              text-overflow: ellipsis;

              .keyTask {
                background-image: url('../../../CommonDP/assets/progress/keyTask.png') !important;
                height: 20px;
                background-repeat: no-repeat;
                cursor: pointer;
              }

              .overdue {
                background-image: url('../../../CommonDP/assets/progress/overdue.png') !important;
                height: 17px;
                width: 17px !important;
                background-repeat: no-repeat;
                cursor: pointer;
              }

              .urging {
                background-image: url('../../../CommonDP/assets/progress/urging.png') !important;
                height: 20px;
                width: 16px !important;
                background-repeat: no-repeat;
                cursor: pointer;
              }
            }
          }

          .gantt_folder_open {
            display: none !important;
          }

          .gantt_file {
            display: none !important;
          }

          .gantt_folder_closed {
            display: none !important;
          }

          .gantt_close {
            background-image: url('../../../CommonDP/assets/fileTable/open.png') !important;
            cursor: pointer;
          }

          .gantt_open {
            background-image: url('../../../CommonDP/assets/fileTable/close.png') !important;
            cursor: pointer;
          }
        }

        .operations {
          width: 100%;
          height: 100%;
          display: none;
          align-items: center;
          justify-content: center;
          margin-left: 10px;

          .urgent {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/urgent.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .edit {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/edit.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .add {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/add.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .detail {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/detail.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .del {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/del.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .shangyi {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/shangyi.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .xiayi {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/xiayi.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .shengji {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/shengji.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .jiangji {
            height: 20px !important;
            width: 23px !important;
            background-image: url('../../../CommonDP/assets/progress/jiangji.png') !important;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          img {
            cursor: pointer;
          }
        }
      }

      .timeline_cell {
        .weekend {
          background: #f4f7f4 !important;
        }

        .without {
          background: #dcdcdc;
          border-color: #dcdcdc;
          box-shadow: 0 0 5px #dcdcdc;

          .gantt_task_progress {
            background: #b4b3b3;
          }
        }

        .low {
          background: #69e2b3;
          border-color: #69e2b3;
          box-shadow: 0 0 5px #69e2b3;

          .gantt_task_progress {
            background: #22ac76;
          }
        }

        .medium {
          background: #a4bafa;
          border-color: #a4bafa;
          box-shadow: 0 0 5px #a4bafa;

          .gantt_task_progress {
            background: #4689f6;
          }
        }

        .high {
          background: #fdd2d2;
          border-color: #fdd2d2;
          box-shadow: 0 0 5px #fdd2d2;

          .gantt_task_progress {
            background: #f75c5c;
          }
        }

        .key {
          background: #000;
          border-color: #000;
          box-shadow: 0 0 5px #000;

          .gantt_task_progress {
            background: #000;
          }
        }
      }
    }

    .setHeader {
      width: 140px;
      height: 205px;
      background-color: #fff;
      font-size: 12px;
      position: absolute;
      text-align: center;
      border: 1px solid #eee;

      .btns {
        width: 100%;
        display: flex;
        position: absolute;
        bottom: 0;
        left: 0;

        /deep/ .el-button {
          width: 50%;
          margin: 0;
        }
      }

      /deep/ .el-checkbox-group {
        width: 100%;
        height:calc(100% - 50px);
        overflow-y:auto;
        .el-checkbox {
          width: 75%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          margin-top: 8px;
          box-sizing: border-box;
        }
      }
    }

    .foldBtn {
      width: 20px;
      height: 35px;
      font-size: 12px;
      position: absolute;
      left: 0;
      top: 16px;
      background-color: #3490f0;
      color: #fff;
      text-align: center;
      border-radius: 0 5px 5px 0;
      cursor: pointer;
    }
  }

  // 弹框 链接任务
  /deep/ .linkTask {
    .el-dialog__header {
      background-color: #fff;

      .el-dialog__title {
        color: black;
      }

      .el-icon-close {
        color: black;
      }
    }

    .el-dialog__body {
      padding: 10px;
      // height 500px
      box-sizing: border-box;
      background-color: #f1f2f6;

      .content {
        width: 100%;
        height: 50%;
        background-color: #fff;
        border-radius: 5px;
        padding: 0px;
        box-sizing: border-box;

        .titlecalss {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 29px;
          font-size: 16px;
          padding: 5px;
        }

        .top, .bottom {
          // height 50%
          .warp {
            height: calc(100% - 29px);
            overflow-y: auto;
            padding: 15px;
            box-sizing: border-box;
            border-top: 1px solid #ebedf0;
          }
        }

        .top {
          margin-bottom: 10px;
        }
      }
    }

    .el-button--primary {
      background: #4777E7;
      border-color: #4777E7;
    }

    .el-button--primary:hover {
      background: #7397EC;
      border-color: #7397EC;
    }

    .el-button--primary.is-plain {
      background: #fff;
      border-color: #4777E7;
      color: #4777E7;
    }

    .el-button--primary.is-plain:hover {
      background: #E1EAFF;
      border-color: #4777E7;
      color: #4777E7;
    }
  }

  // 弹框 图例说明 子项分组管理
  /deep/ .mapDocs {
    .el-dialog__header {
      background-color: #fff;

      .el-dialog__title {
        color: black;
      }

      .el-icon-close {
        color: black;
      }
    }

    .el-dialog__body {
      padding: 10px;
      height: 450px;
      box-sizing: border-box;
      background-color: #fff;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;

      .content {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 5px;
        padding: 20px;
        box-sizing: border-box;
        line-height: 300px;
        display: flex;
        align-items: center;

        .warp {
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .item {
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: left;
            overflow: hidden;

            .progress {
              width: 80%;
              height: 30px;
              margin-right: 10px;
              display: flex;
              align-items: center;

              .solid {
                height: 20px;
                width: 50%;
              }
            }
          }
        }
      }

      .childItemGroup {
        line-height: inherit;
      }
    }

    .el-button--primary {
      background: #4777E7;
      border-color: #4777E7;
    }

    .el-button--primary:hover {
      background: #7397EC;
      border-color: #7397EC;
    }
  }

  // 弹框任务管理
  .add-edit-detail {
    /deep/ .el-dialog {
      width: 1200px;
      margin-top: 5vh !important;

      .el-dialog__header {
        background: #fff;
        padding: 15px 20px 15px;

        .el-dialog__title {
          color: #b lack !important;
        }

        .el-dialog__headerbtn .el-dialog__close {
          color: #b lack !important;
        }
      }

      .el-dialog__body {
        background: #f1f2f6;
        padding: 15px 15px;
        padding-bottom: 15px;

        // height: 750px;
        // overflow-y: auto;
        .el-tree-node__content {
          border-bottom: 1px solid #d9e0ea;
          color: #538be6;
        }
      }

      .el-dialog__footer {
        padding: 10px 20px 10px;
      }
    }
  }

  // 弹框导入任务包
  #eldialogtop3 {
    /deep/ .el-dialog {
      width: 1100px;

      .el-dialog__header {
        background: #4d89f6;
        padding: 15px 20px 15px;

        .el-dialog__title {
          color: #fff !important;
        }

        .el-dialog__headerbtn .el-dialog__close {
          color: #fff !important;
        }
      }

      .el-dialog__body {
        background: #f1f2f6;
        padding: 15px 15px;
        padding-bottom: 15px;

        .el-tree-node__content {
          border-bottom: 1px solid #d9e0ea;
          color: #538be6;
        }
      }

      .el-dialog__footer {
        padding: 10px 20px 10px;
      }
    }
  }
  .myProjectTop{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    border-bottom:1px solid #d3d9e8c4;
    padding: 12px;
      .el-button{
        margin-right: 20px;
      }
  }
  // 弹框 紧前任务
  .preTask {
    .content {
      height: 100%;

      /deep/ .el-tree-node__content {
        border-bottom: 1px solid #d9e0ea;
        color: #538be6;
      }
    }
  }

  /deep/ .gantt_grid_data .gantt_row.odd:hover {
    background-color: #f2f3f5 !important;
  }

  /deep/ .gantt_grid_data .gantt_row:hover {
    background-color: #f2f3f5 !important;
  }

  /deep/ .gantt_grid_data .gantt_row.gantt_selected {
    background-color: #f2f3f5 !important;
  }

  /deep/ .gantt_grid_data .gantt_row.odd.gantt_selected {
    background-color: #f2f3f5 !important;
  }

  /deep/ .gantt_task_row.gantt_selected {
    background-color: #f2f3f5 !important;
  }

  /deep/ .gantt_grid_scale {
    background-color: #f7f9ff;
  }

  /deep/ .gantt_grid_scale .gantt_grid_head_cell {
    color: #2e384d !important;

    #setHeader {
      background-image: url('../../../CommonDP/assets/progress/set.png') !important;
      width: 27px;
      height: 27px;
    }
  }
}
</style>
